(function () {
  'use strict';

  if (window.__qvFcloInitialized) return;
  window.__qvFcloInitialized = true;

  var SECTION_ID = 'api-product-quickview-fclo';
  var root = null;
  var drawer = null;
  var drawerBody = null;
  var overlay = null;
  var closeBtn = null;
  var contentEl = null;
  var loadingEl = null;
  var currentHandle = null;
  var productData = null;
  var activePanel = null;
  var galleryIndex = 0;
  var isOpen = false;
  var eventsBound = false;
  var triggerClickBound = false;

  function getRoot() {
    if (!root) root = document.querySelector('[data-qv-fclo-root]');
    return root;
  }

  function getPanel() {
    if (!contentEl) return null;
    return contentEl.querySelector('[data-qv-fclo-panel]') || contentEl;
  }

  function formatMoney(cents) {
    var currency = (window.theme && window.theme.shopCurrency) || 'INR';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '₹ ' + (cents / 100).toFixed(2);
    }
  }

  function setLoading(show) {
    if (!loadingEl) return;
    loadingEl.hidden = !show;
  }

  function showError(message) {
    var panel = getPanel();
    var errorEl = panel && panel.querySelector('[data-qv-fclo-error]');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function lockScroll() {
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
      bubbles: true,
      detail: drawerBody || drawer
    }));
  }

  function unlockScroll() {
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  function openDrawer() {
    var el = getRoot();
    if (!el || isOpen) return;
    isOpen = true;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
    lockScroll();
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    var el = getRoot();
    if (!el || !isOpen) return;
    isOpen = false;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    unlockScroll();
    document.removeEventListener('keydown', onKeydown);
    setTimeout(function () {
      if (!isOpen) {
        el.hidden = true;
        if (contentEl) contentEl.innerHTML = '';
        productData = null;
        activePanel = null;
        currentHandle = null;
        galleryIndex = 0;
      }
    }, 300);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeDrawer();
  }

  function refreshCartAndOpenSidebar() {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart)
      ? window.theme.routes.cart + '.js'
      : '/cart.js';

    return fetch(cartUrl)
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (cartDrawer) {
          cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        }
      });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          var message = err.description || err.message || 'Could not add to cart';
          if (/cannot find variant/i.test(message)) {
            message = 'Sold out';
          }
          throw new Error(message);
        });
      }
      return res.json();
    });
  }

  function getSelectedOptions(panel) {
    if (!productData || !productData.options) return [];
    var selected = new Array(productData.options.length);
    panel.querySelectorAll('[data-qv-fclo-option-input]:checked').forEach(function (input) {
      var pos = parseInt(input.getAttribute('data-option-position'), 10) - 1;
      selected[pos] = input.value;
    });
    return selected;
  }

  function hasAllOptionsSelected(panel) {
    var options = panel.querySelectorAll('[data-qv-fclo-option]');
    if (!options.length) return true;

    for (var i = 0; i < options.length; i++) {
      if (!options[i].querySelector('[data-qv-fclo-option-input]:checked')) {
        return false;
      }
    }
    return true;
  }

  function findVariant(panel) {
    if (!productData || !productData.variants) return null;

    if (productData.variants.length === 1) {
      return productData.variants[0];
    }

    if (!hasAllOptionsSelected(panel)) return null;

    var selected = getSelectedOptions(panel);
    return productData.variants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        return !selected[i] || selected[i] === opt;
      });
    }) || null;
  }

  function getGalleryThumbs(panel) {
    return panel ? Array.prototype.slice.call(panel.querySelectorAll('[data-qv-fclo-thumb]')) : [];
  }

  function setGalleryIndex(panel, index) {
    var thumbs = getGalleryThumbs(panel);
    if (!thumbs.length) return;

    galleryIndex = Math.max(0, Math.min(index, thumbs.length - 1));
    var thumb = thumbs[galleryIndex];
    var mainImage = panel.querySelector('[data-qv-fclo-main-image]');

    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === galleryIndex);
    });

    if (mainImage && thumb) {
      mainImage.src = thumb.getAttribute('data-image-src');
      mainImage.alt = thumb.getAttribute('data-image-alt') || '';
    }

    var prevNav = panel.querySelector('[data-qv-fclo-gallery-prev]');
    var nextNav = panel.querySelector('[data-qv-fclo-gallery-next]');
    if (prevNav) prevNav.disabled = galleryIndex <= 0;
    if (nextNav) nextNav.disabled = galleryIndex >= thumbs.length - 1;
  }

  function updateVariantUI(panel) {
    var variant = findVariant(panel);
    var idInput = panel.querySelector('[data-qv-fclo-variant-id]');
    var priceEl = panel.querySelector('[data-qv-fclo-price]');
    var addBtn = panel.querySelector('[data-qv-fclo-add-to-cart]');
    var addText = panel.querySelector('[data-qv-fclo-add-text]');

    if (!variant) {
      if (idInput) idInput.value = '';
      if (priceEl && productData) {
        priceEl.textContent = formatMoney(productData.price_min || productData.price);
      }
      if (addBtn) addBtn.disabled = false;
      if (addText) addText.textContent = 'Add to Cart';
    } else {
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      var soldOut = !variant.available;
      if (addBtn) addBtn.disabled = soldOut;
      if (addText) {
        addText.textContent = soldOut ? 'Sold out' : 'Add to Cart';
      }

      if (variant.featured_image && productData && productData.images) {
        var imageIndex = productData.images.findIndex(function (img) {
          return img.id === variant.featured_image.id;
        });
        if (imageIndex > -1) {
          setGalleryIndex(panel, imageIndex);
        }
      }
    }

    var optionGroups = panel.querySelectorAll('[data-qv-fclo-size-options]');
    optionGroups.forEach(function (group) {
      group.querySelectorAll('.qv-fclo__size-btn').forEach(function (label) {
        var input = label.querySelector('input');
        if (!input) return;
        var pos = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        var value = input.value;
        var testOptions = getSelectedOptions(panel).slice();
        testOptions[pos] = value;

        var match = productData.variants.some(function (v) {
          return v.available && v.options.every(function (opt, i) {
            return !testOptions[i] || testOptions[i] === opt;
          });
        });

        input.disabled = !match;
        label.classList.toggle('is-unavailable', !match);
        label.classList.toggle('is-selected', input.checked);
      });
    });

    showError('');
  }

  function bindPanelEvents(panel) {
    activePanel = panel;
    galleryIndex = 0;
    var activeThumb = panel.querySelector('[data-qv-fclo-thumb].is-active');
    if (activeThumb) {
      var thumbs = getGalleryThumbs(panel);
      galleryIndex = Math.max(0, thumbs.indexOf(activeThumb));
    }
    updateVariantUI(panel);
  }

  function handlePanelClick(event) {
    var panel = getPanel();
    if (!panel || !contentEl.contains(event.target)) return;

    var thumb = event.target.closest('[data-qv-fclo-thumb]');
    if (thumb) {
      event.preventDefault();
      var thumbs = getGalleryThumbs(panel);
      setGalleryIndex(panel, thumbs.indexOf(thumb));
      return;
    }

    var prevBtn = event.target.closest('[data-qv-fclo-gallery-prev]');
    if (prevBtn) {
      event.preventDefault();
      setGalleryIndex(panel, galleryIndex - 1);
      return;
    }

    var nextBtn = event.target.closest('[data-qv-fclo-gallery-next]');
    if (nextBtn) {
      event.preventDefault();
      setGalleryIndex(panel, galleryIndex + 1);
      return;
    }

    var colorBtn = event.target.closest('[data-qv-fclo-color-link]');
    if (colorBtn) {
      event.preventDefault();
      var handle = colorBtn.getAttribute('data-qv-fclo-color-link');
      if (handle && handle !== currentHandle) {
        loadProduct(handle, true);
      }
      return;
    }

    var minusBtn = event.target.closest('[data-qv-fclo-qty-minus]');
    if (minusBtn) {
      event.preventDefault();
      var qtyInput = panel.querySelector('[data-qv-fclo-qty-input]');
      if (!qtyInput) return;
      var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 10;
      qtyInput.value = Math.max(min, Math.min(max, (parseInt(qtyInput.value, 10) || min) - 1));
      return;
    }

    var plusBtn = event.target.closest('[data-qv-fclo-qty-plus]');
    if (plusBtn) {
      event.preventDefault();
      var qtyInputPlus = panel.querySelector('[data-qv-fclo-qty-input]');
      if (!qtyInputPlus) return;
      var minVal = parseInt(qtyInputPlus.getAttribute('min'), 10) || 1;
      var maxVal = parseInt(qtyInputPlus.getAttribute('max'), 10) || 10;
      qtyInputPlus.value = Math.max(minVal, Math.min(maxVal, (parseInt(qtyInputPlus.value, 10) || minVal) + 1));
      return;
    }

    var addBtn = event.target.closest('[data-qv-fclo-add-to-cart]');
    if (addBtn) {
      event.preventDefault();
      if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
      var variantInput = panel.querySelector('[data-qv-fclo-variant-id]');
      var qtyEl = panel.querySelector('[data-qv-fclo-qty-input]');
      if (!variantInput || !variantInput.value) {
        showError('Please select all options');
        return;
      }
      addBtn.classList.add('is-loading');
      showError('');
      addToCart(variantInput.value, qtyEl ? qtyEl.value : 1)
        .then(function () {
          closeDrawer();
          return refreshCartAndOpenSidebar();
        })
        .catch(function (err) {
          showError(err.message || 'Something went wrong');
        })
        .finally(function () {
          addBtn.classList.remove('is-loading');
        });
      return;
    }
  }

  function handlePanelChange(event) {
    var panel = getPanel();
    if (!panel || !contentEl.contains(event.target)) return;

    var optionInput = event.target.closest('[data-qv-fclo-option-input]');
    if (optionInput) {
      var group = optionInput.closest('[data-qv-fclo-size-options]');
      if (group) {
        group.querySelectorAll('.qv-fclo__size-btn').forEach(function (label) {
          label.classList.remove('is-selected');
        });
        var label = optionInput.closest('.qv-fclo__size-btn');
        if (label) label.classList.add('is-selected');
      }
      updateVariantUI(panel);
      return;
    }

    var qtyInput = event.target.closest('[data-qv-fclo-qty-input]');
    if (qtyInput) {
      var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 10;
      qtyInput.value = Math.max(min, Math.min(max, parseInt(qtyInput.value, 10) || min));
    }
  }

  function loadProduct(handle, keepOpen) {
    if (!contentEl) return Promise.reject();

    currentHandle = handle;
    setLoading(true);
    showError('');

    if (!keepOpen) {
      openDrawer();
    }

    var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    var sectionUrl = rootUrl + 'products/' + handle + '?section_id=' + SECTION_ID;
    var productUrl = rootUrl + 'products/' + handle + '.js';

    return Promise.all([
      fetch(sectionUrl).then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.text();
      }),
      fetch(productUrl).then(function (res) {
        if (!res.ok) throw new Error('Product data not found');
        return res.json();
      })
    ])
      .then(function (results) {
        var html = results[0];
        productData = results[1];

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var apiContent = doc.querySelector('[data-api-content]');
        if (!apiContent) throw new Error('Quickview content missing');

        contentEl.innerHTML = apiContent.innerHTML;
        var panel = getPanel();
        if (!panel) throw new Error('Quickview panel missing');

        bindPanelEvents(panel);
      })
      .catch(function (err) {
        showError(err.message || 'Could not load product');
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function portalToBody(el) {
    if (el && el.parentElement && el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
  }

  function bindGlobal() {
    var roots = document.querySelectorAll('[data-qv-fclo-root]');
    if (roots.length > 1) {
      for (var i = 1; i < roots.length; i++) {
        roots[i].remove();
      }
    }

    root = document.querySelector('[data-qv-fclo-root]');
    if (!root) return;

    portalToBody(root);
    portalToBody(document.getElementById('qv-fclo-size-chart-modal'));
    portalToBody(document.querySelector('[data-sg-fclo-root]'));

    drawer = root.querySelector('[data-qv-fclo-drawer]');
    drawerBody = root.querySelector('[data-qv-fclo-body]');
    overlay = root.querySelector('[data-qv-fclo-overlay]');
    closeBtn = root.querySelector('[data-qv-fclo-close]');
    contentEl = root.querySelector('[data-qv-fclo-content]');
    loadingEl = root.querySelector('[data-qv-fclo-loading]');

    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    if (!eventsBound && contentEl) {
      contentEl.addEventListener('click', handlePanelClick);
      contentEl.addEventListener('change', handlePanelChange);
      eventsBound = true;
    }

    if (!triggerClickBound) {
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-qv-fclo-open]');
        if (!trigger) return;
        event.preventDefault();
        var handle = trigger.getAttribute('data-product-handle');
        if (handle) loadProduct(handle, false);
      });
      triggerClickBound = true;
    }
  }

  window.QuickviewFclo = {
    open: function (handle) { return loadProduct(handle, false); },
    close: closeDrawer
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindGlobal);
  } else {
    bindGlobal();
  }
})();
